import React from "react";
import { withStyles, CircularProgress } from "@material-ui/core";

function Loader(props) {
  const {
    classes,
    size = 50,
    width = "100%",
    height = "100%",
    marginTop = 0,
  } = props;
  return (
    <div
      className={`${classes.loaderContainer} singleContainer`}
      style={{ width, height, marginTop }}>
      <CircularProgress size={size} />
    </div>
  );
}

const styles = (theme) => ({
  loaderContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "none",
    // padding: "32px 0",
    "& svg": {
      color: theme.colors.text.secondary,
    },
  },
});

export default withStyles(styles)(Loader);
